import { createSlice } from '@reduxjs/toolkit';

const walletSlice = createSlice({
  name: 'wallets',
  initialState: [],
  reducers: {
    walletReducer: {
      reducer: (state, action) => (state = action.payload),
      prepare: (value) => ({ payload: value || [] }),
    },
  },
});

export const { walletReducer } = walletSlice.actions;
export default walletSlice.reducer;